import { render } from "./alarmsManage.vue?vue&type=template&id=2a618cae&scoped=true"
import script from "./alarmsManage.vue?vue&type=script&lang=js"
export * from "./alarmsManage.vue?vue&type=script&lang=js"

import "./alarmsManage.vue?vue&type=style&index=0&id=2a618cae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a618cae"]])

export default __exports__